import { Component, OnInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { CompanyService } from '../../../_services/company.service';
import { PlaceService } from '../../../_services/place.service';
import { OfferService } from '../../../_services/offer.service';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'app-new-offer',
  templateUrl: './new-offer.component.html',
  styleUrls: ['./new-offer.component.css']
})
export class NewOfferComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private creating_offer: boolean;
  private add_company = false;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    openSelectorOnInputClick: true,
    editableDateField: false
  };

  constructor(private elRef: ElementRef, private service: OfferService, private company_service: CompanyService, private place_service: PlaceService) { }

  new_offer = new FormGroup({
    number: new FormControl(),
    seller: new FormControl('', [Validators.required]),
    departure_id: new FormControl('', [Validators.required]),
    arrival_id: new FormControl('', [Validators.required]),
    vehicle: new FormControl('', [Validators.required]),
    quantity: new FormControl('', [Validators.required]),
    departure_date: new FormControl(),
    arrival_date: new FormControl(),
    frequency: new FormControl(0),
    buy_price: new FormControl(''),
    sell_price: new FormControl(''),
    note: new FormControl()
  });

  new_company = new FormGroup({
    email: new FormControl(''),
    name: new FormControl('', [Validators.required]),
    phone: new FormControl('')
  });

  ngOnInit() {

  }



  openModal(field_object: { field, value }) {
    if (field_object) {
      if (field_object.field == "departure_id") this.new_offer.patchValue({ departure_id: field_object.value });
      if (field_object.field == "arrival_id") this.new_offer.patchValue({ arrival_id: field_object.value });
    }

    jQuery('#add-offer-modal').modal({ inverted: true }).modal('show');
    jQuery('.ui.radio.checkbox').checkbox('uncheck');
  }

  newCompany(name) {
    this.new_company.patchValue({ name: name });
    this.new_offer.patchValue({ seller: 0 });
    this.add_company = true;
  }

  submitOfferForm() {
    this.new_offer.disable();
    this.creating_offer = true; // Disable the loading button apparition
    jQuery('#add-offer-modal').modal({ closable: false })

    // Set Dates values correctly
    if (this.new_offer.value.departure_date && this.new_offer.value.departure_date.formatted) this.new_offer.patchValue({ departure_date: this.new_offer.value.departure_date.formatted })
    if (this.new_offer.value.arrival_date && this.new_offer.value.arrival_date.formatted) this.new_offer.patchValue({ arrival_date: this.new_offer.value.arrival_date.formatted })

    if (this.add_company) {
      this.new_company.disable();
      this.company_service.createCompany(this.new_company.value) // Create the Contact
        .subscribe(response => {
          this.new_offer.patchValue({ seller: response.id });
          this.createOffer();
        });
    } else {
      this.createOffer();
    }

  }

  createOffer() {
    this.service.createOffer(this.new_offer.value)
      .subscribe(response => {
        jQuery('#add-offer-modal').modal({ closable: true }).modal('hide'); // Set the modal closable & Close the modal
        this.creating_offer = false; // Disable the loading button apparition
        this.add_company = false;
        this.new_offer.enable(); // Re Enable the Form
        // this.new_offer.reset(); // Reset It
        jQuery('#add-offer-modal').find('.dropdown').dropdown('set value', '');
        jQuery('#add-offer-modal').find('.dropdown').dropdown('set text', '');
        this.refresh.emit(true); // Emmit the refresh Event
      })
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/offer/new-offer/new-offer.component.ts